import { render, staticRenderFns } from "./RegistrationStepper.vue?vue&type=template&id=50134022&scoped=true"
import script from "./RegistrationStepper.vue?vue&type=script&lang=js"
export * from "./RegistrationStepper.vue?vue&type=script&lang=js"
import style0 from "./RegistrationStepper.vue?vue&type=style&index=0&id=50134022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50134022",
  null
  
)

export default component.exports